import Loadable from '../../components/loadable';

const PlayWorkoutExerciseVideoModal = Loadable({
  loader: () => import('react/pages/workouts/play_workout_exercise_video_modal'),
  type: 'modal',
});

angular.module('gym').value('PlayWorkoutExerciseVideoModal', PlayWorkoutExerciseVideoModal);
